<template>

    <div id="app">

        <breakpoint-debugger v-if="bpDebugger || debug"></breakpoint-debugger>

        <scroll-container @change="updateState">

            <app-header></app-header>

            <router-view></router-view>

        </scroll-container>

        <div v-if="viewportItems" style="position: fixed;z-index: -99999;top: 0;left: 0;background-color:rgba(0,0,0, 0.5); color: rgba(255,255,255, 1);font-family: monospace;white-space: pre;text-align: left;">{{ itemsInViewport }}</div>

    </div>

</template>


<script>

    import _ from 'lodash';
    import { config } from '@/config';
    import BreakpointDebugger from './components/BreakpointDebugger';
    import AppHeader from "./components/AppHeader";

    export default {

        name: 'App',

        components: {
            BreakpointDebugger,
            AppHeader
        },

        data() {
            return {
                debug: config.debug,
                viewportItems: true,
                bpDebugger: false
            };
        },

        created() {

        },

        computed: {

            /**
             * @method itemsInViewport
             * @description
             * @returns {{}}
             */
            itemsInViewport() {
                //console.log(this.state);
                //console.log('itemsInViewport', _.pickBy(this.state, ({ isInViewport }) => isInViewport));
                //console.log('--------------');

                let _this = this;

                //console.log('_this', _this);

                _.forOwn(this.state, function(val, key) {
                    //console.log(key, val);
                    //console.log(key.split('-')[1]);
                    //console.log(key.toString());
                    let relPathEl = document.querySelector('[data-relid="' + key.split('-')[1] + '"]');
                    //console.log(relPathEl);
                    //console.log(relPathEl.dataset.relpath);

                    if (val.isInViewport && val.isFullyInViewport) {
                        //console.log('DING!!');
                        _this.$router.replace({ path: relPathEl.dataset.relpath });
                    }
                });
                //console.log(_.pickBy(this.state, ({ isInViewport }) => isInViewport));
                return _.pickBy(this.state, ({ isInViewport }) => isInViewport);
                //return {};
            }

        },

        watch: {

        },

        methods: {

            /**
             * @method updateState
             * @description
             * @param state
             */
            updateState(state) {
                this.state = state;
            },

            /**
             * @method onChange
             * @description
             * @param state
             */
            onChange(state) {
                console.log('change', state);
            }

        }

    }

</script>


<style lang="scss">

    #app {
        font-family: $font-coconpro-bold;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2C3E50;
        overflow: hidden;
    }

</style>
